import type {SchemaService, ComponentFeature} from '@wix/document-services-types'
import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import {type ReferredDataItemsIterateeContext, forEachReferredDataItem} from '@wix/import-export-utils'
import {COMPONENT_FEATURES} from '@wix/format-converter-schemas'

export const unpack: SingleComponentPluginFunction = (rawComponentExport: any, schemaService: SchemaService) => {
    const {data, structure} = rawComponentExport
    const defaultStructure = schemaService.createItemAccordingToSchema(structure.type, 'structure')

    _.defaults(rawComponentExport.structure, defaultStructure)

    _.forOwn(COMPONENT_FEATURES, ({namespace, alias}: ComponentFeature) => {
        const dataItem = data[alias]
        if (!dataItem) {
            return
        }

        forEachReferredDataItem(
            schemaService,
            dataItem,
            namespace,
            ({item, namespace: itemNamespace}: ReferredDataItemsIterateeContext) => {
                const defaultItem = schemaService.createItemAccordingToSchema(item.type, itemNamespace)

                _.defaults(item, defaultItem)
            }
        )
    })
}
